<script>
import NumberRoller from '@components/number-roller.vue'
import Subslide from '@components/slide-subslide.vue'

export default {
  components: { NumberRoller, Subslide },
  props: {
    report: {
      type: Object,
      required: true,
    },
    isActive: {
      type: Boolean,
      required: false,
      default: false,
    },
    subslide: {
      type: Number,
      required: false,
      default: -1,
    },
  },
  computed: {
    conversion() {
      return this.report.configuration.conversion
    },
    shouldUseCompanySizeConversion() {
      return this.conversion.companySize.active === true
    },
    pageViewConversion() {
      return (
        this.report.data.pageViews * (this.conversion.pageViews.value / 100)
      )
    },
    websiteReferralConversion() {
      if (!this.conversion.websiteReferrals.active) {
        return 0
      }
      return (
        (this.report.data.events.websiteReferrals +
          (this.report.data.events.instagramReferrals || 0)) *
        (this.conversion.websiteReferrals.value / 100)
      )
    },
    totalConversions() {
      return (
        Math.round(this.pageViewConversion) +
        Math.round(this.websiteReferralConversion)
      )
    },
    companySize() {
      return this.conversion.companySize.value
    },
    convertedGuests() {
      return this.totalConversions * this.companySize
    },
  },
}
</script>
<template>
  <div>
    <i18n path="conversion-page-views.heading" tag="h3">
      <NumberRoller
        :delay="200"
        :should-start="isActive"
        :to="totalConversions || 0"
        :decimals="0"
      />
    </i18n>
    <ul>
      <template v-if="shouldUseCompanySizeConversion">
        <Subslide tag="li" :index="0" :current-index="subslide">
          <i18n path="conversion.visitor_company" tag="h4"
            ><BaseNumber :number="companySize" :decimals="1"
          /></i18n>
        </Subslide>
        <Subslide tag="li" :index="1" :current-index="subslide">
          <i18n path="conversion.visitor_total" tag="h4"
            ><BaseNumber :number="convertedGuests" :decimals="0"
          /></i18n>
        </Subslide>
      </template>
    </ul>
    <Subslide
      :index="shouldUseCompanySizeConversion ? 2 : 0"
      :current-index="subslide"
    >
      <p>
        <BaseButton
          :is-primary="true"
          icon="question-mark"
          @click="$emit('help')"
        >
          <span>{{ $t('conversion-page-views.help.title') }}</span>
        </BaseButton>
      </p>
    </Subslide>
  </div>
</template>
